import { render, staticRenderFns } from "./SurveyAnswer.vue?vue&type=template&id=7b2e0d8e&scoped=true"
import script from "./SurveyAnswer.vue?vue&type=script&lang=js"
export * from "./SurveyAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2e0d8e",
  null
  
)

export default component.exports